<template>
  <div class="view-container">
    <div class="tabs-wrapper">
      <a-row justify="start" type="flex" :gutter="22">
        <a-col :span="6">
          <a-input-search
            placeholder="请输入关键字"
            @search="onSearch"
            @change="onSearch"
            size="default"
            v-model="keyword"
          />
        </a-col>
      </a-row>
      <a-row style="margin-top: 10px">
        <a-table
          :columns="columns"
          :rowKey="record => record.id"
          :dataSource="tableData"
          :bordered="true"
          :rowClassName="tableRowClass"
          :pagination="pagination"
          @change="paginationChange"
          size="small"
        >
          <template slot="cell" slot-scope="text">
            <format-html :text="text" :keyword="keyword" />
          </template>
        </a-table>
      </a-row>
    </div>
  </div>
</template>

<script>
import { getLoginLog } from '@/api/log'
import moment from 'moment'
export default {
  data() {
    return {
      columns: [],
      tableData: [],
      // rowKeys: [],
      // rowSelection: {
      //   onChange: selectedRowKeys => {
      //     this.rowKeys = selectedRowKeys
      //   }
      // },
      pagination: {
        showSizeChanger: true,
        defaultCurrent: 1,
        defaultPageSize: 15,
        pageSizeOptions: ['10', '15', '20', '30', '40'],
        showTotal: total => {
          return `共 ${total} 条数据`
        }
      },
      keyword: ''
    }
  },
  created() {
    this.columns = [
      {
        title: '登录时间',
        dataIndex: 'created_at',
        scopedSlots: { customRender: 'cell' },
        customRender: text => {
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title: '登录人账号',
        dataIndex: 'username',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '昵称',
        dataIndex: 'name',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: 'IP地址',
        dataIndex: 'ip',
        scopedSlots: { customRender: 'cell' }
      }
    ]
    this.fetchData()
  },
  methods: {
    fetchData() {
      let { keyword, pagination } = this
      keyword = keyword.trim()
      const page = pagination.current || pagination.defaultCurrent
      const size = pagination.size || pagination.defaultPageSize
      getLoginLog({ keyword, page, size }).then(resp => {
        let { result: res } = resp
        this.tableData = res.rows
        pagination.total = res.total
        this.pagination = JSON.parse(JSON.stringify(pagination))
      })
    },
    paginationChange(pagination) {
      this.pagination = pagination
      this.fetchData()
    },
    onSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    tableRowClass(record, index) {
      if (index % 2 === 0) {
        return 'row-class-even'
      } else {
        return 'row-class-odd'
      }
    }
  }
}
</script>

<style></style>
